import React from 'react';
import Icon from '../../../components/AppIcon';

const ResultsTabNavigation = ({ activeTab, onTabChange, counts }) => {
  const tabs = [
    {
      id: 'successful',
      label: 'Successful',
      icon: 'CheckCircle',
      count: counts.successful,
      color: 'text-success'
    },
    {
      id: 'failed',
      label: 'Failed',
      icon: 'XCircle',
      count: counts.failed,
      color: 'text-error'
    },
    {
      id: 'duplicates',
      label: 'Duplicates',
      icon: 'Copy',
      count: counts.duplicates,
      color: 'text-warning'
    },
    {
      id: 'manual',
      label: 'Manual Review',
      icon: 'AlertTriangle',
      count: counts.manual,
      color: 'text-warning'
    }
  ];

  return (
    <div className="border-b border-border">
      <div className="flex space-x-0 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors duration-200 whitespace-nowrap ${
              activeTab === tab.id
                ? 'border-primary text-primary bg-primary/5' :'border-transparent text-text-secondary hover:text-text-primary hover:bg-surface-secondary'
            }`}
          >
            <Icon name={tab.icon} size={16} className={activeTab === tab.id ? 'text-primary' : tab.color} />
            <span>{tab.label}</span>
            {tab.count > 0 && (
              <span className={`px-2 py-0.5 text-xs rounded-full ${
                activeTab === tab.id 
                  ? 'bg-primary text-primary-foreground' 
                  : 'bg-surface-secondary text-text-muted'
              }`}>
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ResultsTabNavigation;